export default __webpack_public_path__ + "static/media/permit_cost.db0a459a.svg";